// extracted by mini-css-extract-plugin
export default {"ExtraPerformanceAdviceSection":"style_ExtraPerformanceAdviceSection__r4V7N","GlobalText2":"style_GlobalText2__+g7b+"};